// @flow

import React from 'react';
import SearchFilters from 'search/components/SearchFilters';
import Spinner from 'common/components/Spinner';
import SearchResults from 'search/components/SearchResults';

import SearchParamsStore from 'search/stores/ParamsStore';
import SearchResultsStore from 'search/stores/ResultsStore';

import SearchAPI from 'search/api/searchAPI';
import SearchAPIActionCreators from 'search/actions/SearchAPIActionCreators';

import satisfiesMediaQuery from 'utils/satisfiesMediaQuery';

import DocumentTitle from 'react-document-title';

import cx from 'classnames';

import { type Results, type Params } from 'search/types';

const getStateFromStores = () => {
  return {
    params: SearchParamsStore.get(),
    isLoading: SearchResultsStore.isLoading(),
    results: SearchResultsStore.get(),
    activeResultId: SearchResultsStore.activeResultId()
  };
};

type Props = {|
  initialResults: Results,
  initialParams: Params,
  eventTypes: Array<{|
    id: number,
    name: string
  |}>,
  venueServices: Array<any>,
  venueTypes: Array<any>,
  isMobile: boolean | null,
  isTablet: boolean,
  features: {|
    edit_relevance?: boolean
  |}
|};
type State = { ... };

class SearchApp extends React.Component<Props, State> {
  isLazyLoadingMapCode: boolean;

  UNSAFE_componentWillMount() {
    SearchAPIActionCreators.setInitialResults(this.props.initialResults);
    SearchAPIActionCreators.setInitialParams(this.props.initialParams);

    // Keep this value out of `this.state` as it is not used in `render`
    this.isLazyLoadingMapCode = false;

    this.setState(
      // $FlowFixMe STATE
      Object.assign({}, getStateFromStores(), {
        isFiltersVisible: !this.props.isMobile,
        isSmallScreen: !!this.props.isMobile,
        isMapboxLoaded: false,
        MapSearch: null
      })
    );
  }

  componentDidMount() {
    // Boot up SearchAPI's History API etc. stuff
    SearchAPI.initialize();

    window.addEventListener('resize', this._handleResize);
    this._handleResize();

    SearchParamsStore.addChangeListener(this._onChange);
    SearchResultsStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResize);
    SearchParamsStore.removeChangeListener(this._onChange);
    SearchResultsStore.removeChangeListener(this._onChange);
  }

  render() {
    // $FlowFixMe STATE
    const highlightCapacitySitting = !this.state.params.people_filter;

    const showFiltersButtonClasses = cx({
      expand: true,
      success: true,
      small: true,
      // $FlowFixMe STATE
      'is-toggled': this.state.isFiltersVisible
    });

    const showSearchFilters =
      // $FlowFixMe STATE
      this.state.isFiltersVisible || !this.state.isSmallScreen;
    const openInNewTab = !this.props.isMobile && !this.props.isTablet;

    // $FlowFixMe STATE
    const MapSearch = this.state.MapSearch;

    return (
      <div id="venues">
        {/* $FlowFixMe STATE*/}
        <DocumentTitle title={this.state.results.meta.title} />
        {/* $FlowFixMe STATE*/}
        {this.state.isSmallScreen && (
          <div className="m-mobile-filter-container">
            <button
              className={showFiltersButtonClasses}
              onClick={this._toggleFilters}
            >
              <span>
                <i className="fa fa-search" />{' '}
                {__('search.search.toggle_filters')}
              </span>
            </button>
          </div>
        )}
        {showSearchFilters && (
          <SearchFilters
            // $FlowFixMe STATE
            params={this.state.params}
            // $FlowFixMe STATE
            results={this.state.results}
            eventTypes={this.props.eventTypes}
            venueServices={this.props.venueServices}
          />
        )}
        {/* $FlowFixMe STATE*/}
        {this.state.isLoading && (
          <div className="m-search-fixed-spinner">
            <Spinner text={__('search.search.loading')} />
          </div>
        )}
        <SearchResults
          // $FlowFixMe STATE
          results={this.state.results}
          // $FlowFixMe STATE
          activeResultId={this.state.activeResultId}
          highlightCapacitySitting={highlightCapacitySitting}
          openInNewTab={openInNewTab}
          // $FlowFixMe STATE
          params={this.state.params}
          // $FlowFixMe STATE
          isLoading={this.state.isLoading}
          features={this.props.features}
        />
        {MapSearch &&
          // $FlowFixMe STATE
          this.state.isMapboxLoaded &&
          // $FlowFixMe STATE
          !this.state.isSmallScreen && (
            <MapSearch
              // $FlowFixMe STATE
              isLoading={this.state.isLoading}
              // $FlowFixMe STATE
              results={this.state.results}
              // $FlowFixMe STATE
              activeResultId={this.state.activeResultId}
            />
          )}
      </div>
    );
  }

  _handleResize = () => {
    window.requestAnimationFrame(() => {
      const isSmallScreen = !satisfiesMediaQuery('topbar');

      if (!isSmallScreen) {
        this._lazyLoadMapCode();
      }

      // $FlowFixMe STATE
      this.setState({ isSmallScreen });
    });
  };

  _lazyLoadMapCode = () => {
    // Bail out if we're already in the process of loading the map related code
    if (this.isLazyLoadingMapCode) return;
    this.isLazyLoadingMapCode = true;

    // Use two splitpoints to try to get the mapbox to a chunk shared between search and
    // venue page, i.e. use two different `import()` calls
    import('setupMapbox').then(() => {
      // $FlowFixMe STATE
      this.setState({
        isMapboxLoaded: true
      });
    });

    import('search/components/MapSearch')
      .then(mod => mod.default)
      .then(MapSearch => {
        // $FlowFixMe STATE
        this.setState({
          MapSearch
        });
      });
  };

  /**
   * Event handler for 'change' events coming from the stores
   */
  _onChange = () => {
    // $FlowFixMe STATE
    this.setState(getStateFromStores());
  };

  _toggleFilters = () => {
    // $FlowFixMe STATE
    this.setState({
      // $FlowFixMe STATE
      isFiltersVisible: !this.state.isFiltersVisible
    });
  };
}

export default SearchApp;
